import { StorageBase } from '@capsicum/common';

export class LocalStorageService extends StorageBase {
	async getItem(key: string): Promise<null | string> {
		return await localStorage.getItem(key);
	}

	async setItem(key: string, value: string): Promise<void> {
		await localStorage.setItem(key, value);
	}

	async removeItem(key: string): Promise<void> {
		await localStorage.removeItem(key);
	}

	async hasKey(key: string): Promise<boolean> {
		const value = localStorage.getItem(key);

		return value !== null;
	}

	async clear(): Promise<void> {
		await localStorage.clear();
	}
}
